export const createBusinessApi = (api) => ({
  getMyBusiness: () => api.get("/myBusiness"),
  getMyBusinessById: (id) => api.get(`/myBusiness/${id}`),
  createMyBusiness: (data) => api.post("/myBusiness", data),
  updateMyBusiness: (id, data) => api.put(`/myBusiness/${id}`, data),
  deleteMyBusiness: (id) => api.delete(`/myBusiness/${id}`),
});
